import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewCountryPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_COUNTRY,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageCountryPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_COUNTRY,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createCountryPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_COUNTRY,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewProjectPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_PROJECT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageProjectPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_PROJECT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createProjectPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_PROJECT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewMilestonesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_PROJECT_MILESTONE,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageMilestonesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_PROJECT_MILESTONE,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewVisitsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_COUNTRY_VISITS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageVisitsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_COUNTRY_VISITS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createVisitsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_COUNTRY_VISITS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewContactsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INTP_CONTACTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
